import { Component, HostListener, inject, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import { CognitoService } from '../../../auth/cognito.service';
import { GlobalService } from '../../../auth/global.service';
import { PermissionDirective } from '../../../auth/permission.directive';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, PermissionDirective],
  templateUrl: './header.html',
  styleUrl: './header.css',
})
export class HeaderComponent implements OnInit {
  isMenuOpen = false;
  isLoggedIn = false;
  showLogoutConfirm = false;
  protected authService = inject(AuthService);
  permissionLoaded = false;
  isAuthPage = false;
  openDropdown: string | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private globalService: GlobalService,
    private cognitoService: CognitoService,
  ) {}

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.openDropdown = null;
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.openDropdown = null;
  }

  toggleDropdown(name: string, event: MouseEvent): void {
    event.stopPropagation();
    this.openDropdown = this.openDropdown === name ? null : name;
  }

  closeDropdown(): void {
    this.openDropdown = null;
  }

  openMenu(e: any) {
    this.isMenuOpen = true;
  }

  closeMenu(e: any) {
    this.isMenuOpen = false;
  }

  onSubmenuSelect(path: string) {
    this.isMenuOpen = false;
    this.router.navigate([path]);
    if (document.activeElement instanceof HTMLElement)
      document.activeElement.blur();
  }

  ngOnInit() {
    const authPaths = ['/login', '/forgotpassword', '/changepassword'];
    const isAuth = (url: string) => authPaths.some((p) => url.startsWith(p));

    this.isAuthPage = isAuth(this.router.url);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isAuthPage = isAuth(event.urlAfterRedirects || event.url);
        this.openDropdown = null;
      }
    });

    this.globalService.getPermissions().subscribe((isLoaded) => {
      console.log('HeaderComponent: Permissions loaded:', isLoaded);
      this.permissionLoaded = isLoaded;
    });
    this.globalService.getLoggedIn().subscribe((status) => {
      this.isLoggedIn = status;
    });
    this.cognitoService.isAuthenticated().then((status) => {
      if (status) {
        console.log('HeaderComponent: isAuthenticated', status);
      }
      this.isLoggedIn = status?.getUsername() ? true : false;
      this.globalService.setLoggedIn(status);
      this.authService.loadPermissions().then();
    });
    console.log('header route', this.route.snapshot.url);
  }

  logout() {
    this.showLogoutConfirm = true;
  }

  confirmLogout() {
    this.showLogoutConfirm = false;
    this.router.navigate(['/']);
    this.cognitoService.signOut().then(() => {
      window.location.reload();
    });
  }

  cancelLogout() {
    this.showLogoutConfirm = false;
  }
}
